<script setup lang="ts">

</script>

<template>
  <img src="@/assets/logo.png" alt="logo" class="w-10 h-10" />
</template>